module.exports = __webpack_public_path__ + "static/img/case01.3a74eeec.jpg";